<template>
  <div>
    <div>
      <img :src="require('@/assets/image/premium/medilinkGroupZRY_head.png')" alt="">
      <h2 class="product_title">MediLink-Global中间带·臻荣耀团体版</h2>
    </div>
    <div class="card">
      <h2 class="title">企业基本信息</h2>
      <a-form-model :model="form" layout="horizontal" :colon="false" :rules="formRule" ref="quoteForm" :label-col="{ span: 6 }" >
          <a-form-model-item label="投保企业名称" :required="true" prop="phName" :wrapper-col="{ lg: 12, sm: 12 }">
              <a-input v-model="form.phName" placeHolder="请输入准确的企业名称" allow-clear @blur="getIdNumber"></a-input>
          </a-form-model-item>
          <a-form-model-item label="统一社会信用代码" :require="true" prop="phIdNumber" :wrapper-col="{ lg: 12, sm: 12 }">
              <a-input v-model="form.phIdNumber" @blur="dateToParent"></a-input>
          </a-form-model-item>
          <a-form-model-item label="期望生效时间" :require="true" prop="effectiveDate" :wrapper-col="{ lg: 12, sm: 12 }">
              <a-date-picker v-model="form.effectiveDate" placeHolder="请选择生效时间" :disabledDate="disabledDate" @change="effectiveChange" format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
          </a-form-model-item>
          <a-form-model-item label="询价人姓名" :require="true" prop="contactsName" :wrapper-col="{ lg: 12, sm: 12 }">
              <a-input v-model="form.contactsName" placeHolder="请输入询价人姓名" @blur="dateToParent" allow-clear />
          </a-form-model-item>
          <a-form-model-item label="询价人手机号码" :require="true" prop="contactsPhone" :wrapper-col="{ lg: 12, sm: 12 }">
              <a-input v-model="form.contactsPhone" placeHolder="请输入询价人手机号码" @blur="dateToParent" allow-clear />
          </a-form-model-item>
          <a-form-model-item label="是否新保" :require="true" prop="isNewPolicy" :wrapper-col="{ lg: 12, sm: 12 }">
              <a-select v-model="form.isNewPolicy" @change="dateToParent">
                <a-select-option value="Y">是</a-select-option>
                <a-select-option value="N">否</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item v-if="form.isNewPolicy === 'N'" label="上年保单号" prop="lastYearPolicyNo" :wrapper-col="{ lg: 12, sm: 12 }">
              <a-input v-model="form.lastYearPolicyNo" @blur="dateToParent" allow-clear></a-input>
          </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    baseInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        phName: "",
        phIdNumber: "",
        effectiveDate: "",
        contactsName: "",
        contactsPhone: "",
        isNewPolicy: "Y",
        lastYearPolicyNo: "",
        phIdType: "01", // 证件类型 默认统一信用代码
      },
      formRule: {
        phName: [
          { required: true, message: "请输入企业名称" },
          { validator: this.nameValidate, trigger: "blur" }
        ],
        phIdNumber: [{ required: true, message: "请输入统一社会信用代码" }],
        effectiveDate: [{ required: true, message: "请选择期望生效时间" }],
        contactsName: [{ required: true, message: "请输入询价人姓名" }],
        contactsPhone: [{ required: true, message: '请输入正确手机号', trigger: 'blur', pattern: /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/ }],
        lastYearPolicyNo: [{required: true, message: "请输入上年保单号"}]
      },
      prohibitedIndustries: ["学校", "幼儿园", "小学", "中学", "大学", "律师", '律所'], //限制行业
    }
  },
  mounted() {
    this.form = {...this.form, ...this.baseInfo};
  },
  methods: {
    dateToParent() {
      this.$emit("setInfo", this.form);
    },
    // 修改生效日期 默认将结束日期置为1年后
    effectiveChange(val) {
      if(val) {
        this.form.expireDate = moment(val).add(1, "year").subtract(1, "day").format("YYYY-MM-DD")
      }
      this.dateToParent()
    },
    // 生效日期禁选今天及今天之前
    disabledDate(current) {
      return current && current < moment().endOf("day");
    },
    // 企业名称校验 完整性校验/学校律所校验
    nameValidate(rule, value, callback) {
      if(!value) {
        return callback(new Error("请输入投保企业名称"));
      }
      // 复用的MediLink-Global中端小团体医疗保险里的接口，为了验证一下名称对不对
      this.$api.validCustomerName({name: value, pageSource: 'outer' }).then(res => {
          const data = res.data
          console.log(data)
          if(data.returnCode === '9901') {
              callback(data.returnMsg)
          } else {
              callback()
          }
      }).catch((res) => {
          const data = res.data
          // 该客户询价记录已存状态不提示
          if(data.returnCode === '9902') {
            this.$message.destroy()
          }
          callback()
      })
    },
    // 根据投保人名称获取社会统一信用码
    getIdNumber(e) {
      const val = e.target.value;
      this.$tools.queryCompanyIdNum("03", val, (error, idNumber) => {
        if (!error) {
          this.form.phIdNumber = idNumber;
          this.dateToParent();
          this.$refs.quoteForm.clearValidate(['phIdNumber'])
        } else {
          this.$message.error(error);
        }
      })
    },
    // 表单校验，父级触发
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.quoteForm.validate((valid) => {
          if(!valid) {
            window.scrollTo({
              top: 300,
              behavior: "smooth"
            })
            reject(false);
            return;
          }
          resolve(this.form);
        })
      })
    },
  }

}
</script>

<style lang="scss" scoped>
.product_title {
  font-size: 30px;
  text-align: center;
  font-weight: bold;
  margin-top: 10px;
}
::v-deep .ant-calendar-picker{
  width: 100%;
}
</style>